<template>
    <section class="pda-default">
        <div class="mdc-card mdc-elevation--z3 pdb-16" v-if="lessonsList.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('676')}}
                <!-- 강의 -->
            </div>
            <div v-for="(lesson, index) in lessonsList" :key="index">
                <div class="d-flex flex-row pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img src="@/images/icon/exam_icon.png" v-if="lesson.contentsType.value === 'EXAM_PAPER'" class="profile">
                        <img src="@/images/icon/contents_icon.png" v-else class="profile">
                    </div>
                    <div class="pdl-8 pdr-8">
                        <div class="t-body1">
                            {{lesson.name}}
                            <div class="t-body3 t-color-gray2 mgt-3">
                                {{$t(lesson.contentsType.translate)}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-row mgt-14" v-if="lessonsList.length > index+1">
                    <div class="mgl-16 mgr-16 w-40"></div>
                    <div class="flex-grow-1">
                        <hr class="divider">
                    </div>
                </div>

                
            </div>
        </div>


        <div class="mdc-card mdc-elevation--z3 mgt-16 pdb-16" v-if="missionsList.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('681')}}
                <!-- 미션 -->
            </div>
            <div v-for="(mission, index) in missionsList" :key="index">
                <div class="d-flex flex-row pdt-16  mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8">
                        <img src="@/images/icon/misson_icon.png" class="profile">
                    </div>
                    <div class="pdl-8 pdr-8">
                        <div class="t-body1">
                            {{mission.name}}
                        </div>
                    </div>
                </div>

                <div class="mgt-14" v-if="lessonsList.length > index+1"></div>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 차수 상세 레슨 탭 컴포넌트(degree view lesson tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'

export default {
    data() {
        return {
            lessonData: null,
            lessonsList: [],
            missionData: null,
            missionsList: [],
        }
        
    },
    
    mounted() {
        this.fetchData()
    },

    methods: {
        
        // 차시정보 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            //차시 정보(lesson list)
            degreeApi.guestLearnOnlineViewCourses(params).then((response) => {
                this.lessonData = response.data.data
                // 과정의 차시 정보만 병합(Merge lesson information from the course)
                _.each(this.lessonData, (course) => {
                    this.lessonsList = this.lessonsList.concat(course.lessons)
                })
            }).catch((err) => {
            })

            // 미션 정보(mission list)
            degreeApi.guestLearnOnlineViewMission(params).then((response) => {
                this.missionData = response.data.data
                if (this.missionData) {
                    this.missionsList = this.missionData[0].assignments
                }
            }).catch((err) => {
            })

           
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },
    }
}
</script>
